import { Chip, Divider, Tooltip, Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import useStyles from "./styles";
import dayjs from "dayjs";

export default function DisponibilidadeApiComponent(params) {
	const {
		tempo = 0, //dias
		dataApisFilter = [
			// [],
			// [],
			// [],
			// [],
			// [
			//   {
			//     value: 1,
			//     clock: "2025-09-03T12:00:00.000Z",
			//   },
			//   {
			//     value: 0,
			//     clock: "2025-09-03T13:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T14:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T15:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T16:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T17:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T18:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T19:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-03T20:00:00.000Z",
			//   },
			// ],
			// [
			//   {
			//     value: 1,
			//     clock: "2025-09-04T13:00:00.000Z",
			//   },
			//   {
			//     value: 1,
			//     clock: "2025-09-04T14:00:00.000Z",
			//   },
			// ],
		],
		dias = [
			// "2025-08-29",
			// "2025-08-30",
			// "2025-08-31",
			// "2025-09-01",
			// "2025-09-02",
			// "2025-09-03",
			// "2025-09-04",
		],
		windowWidth = null,
	} = params;

	const theme = useTheme();
	const styles = useStyles(theme);

	//Funcao para analisar a atividade de um dia em especifico
	const analiseAtividadeApiDay = (requisicoesDoDia) => {
		if (!requisicoesDoDia || requisicoesDoDia?.length === 0) return 0;

		const sucessos = requisicoesDoDia?.filter(
			(data) => data?.value === 1
		)?.length;

		return parseFloat((sucessos * 100) / requisicoesDoDia?.length)?.toFixed(2);
	};

	//Funcao para analisar a atividade de todos os dias
	const analiseAtividadeApi = (dados) => {
		const diasComRequisicoes = dados?.filter((dia) => dia && dia?.length > 0);

		if (diasComRequisicoes?.length === 0) return 0.0;

		const somaPorcentagens = diasComRequisicoes?.reduce((total, dia) => {
			return total + parseFloat(analiseAtividadeApiDay(dia));
		}, 0);

		const analiseCompleto = (
			somaPorcentagens / diasComRequisicoes?.length
		)?.toFixed(2);
		return isNaN(analiseCompleto) ? 0.0 : analiseCompleto;
	};

	const porcentagemGeral = analiseAtividadeApi(dataApisFilter?.slice(-tempo));

	return (
		<Box sx={styles.containerApi}>
			<Box sx={styles.containerAnaliseApi}>
				{Array.isArray(dataApisFilter?.slice(-tempo)) &&
					dataApisFilter?.slice(-tempo)?.map((requisicoesDoDia, indexApi) => {
						const porcentagemDia = analiseAtividadeApiDay(requisicoesDoDia);
						const temDados = requisicoesDoDia?.length > 0;

						return (
							<Tooltip
								arrow
								PopperProps={{
									modifiers: [
										{
											name: "preventOverflow",
											options: {
												boundary: "viewport",
											},
										},
									],
								}}
								componentsProps={styles.tooltipStyles}
								title={
									temDados ? (
										<>
											<Box sx={styles.containerData}>
												<Typography sx={styles.tituloData}>
													{dayjs(requisicoesDoDia?.[0]?.clock)?.format(
														"DD/MM/YYYY HH:mm"
													)}
												</Typography>
											</Box>

											<Box sx={styles.containerRequisicao}>
												<Box sx={styles.containerStatusRequisicao} />
												<Typography sx={styles.tituloRequisicao}>
													Registros de status ativos:
													{
														requisicoesDoDia.filter((data) => data?.value === 1)
															?.length
													}
												</Typography>
											</Box>

											<Box sx={styles.containerFalha}>
												<Box sx={styles.containerStatusFalha} />
												<Typography sx={styles.tituloRequisicao}>
													Registros inativos ou falhas:
													{requisicoesDoDia?.length -
														requisicoesDoDia?.filter(
															(data) => data?.value === 1
														)?.length}
												</Typography>
											</Box>
										</>
									) : (
										<>
											<Box sx={styles.containerSemDados}>
												<Typography sx={styles.tituloData}>
													{dayjs(dias[indexApi])?.format("DD/MM/YYYY")}
												</Typography>
											</Box>
											<Typography sx={styles.tituloRequisicao}>
												Sem dados para esse período
											</Typography>
										</>
									)
								}
							>
								<Box
									bgcolor={
										temDados
											? porcentagemDia > 90
												? theme.palette.colors.green.light
												: porcentagemDia > 80
												? theme.palette.colors.yellow.dark
												: theme.palette.colors.red.dark
											: theme.palette.mode === "dark"
											? theme.palette.colors.black.medium
											: theme.palette.colors.black.light
									}
									sx={{
										...styles.containerDia,
										width:
											windowWidth > 2500
												? "8px"
												: windowWidth < 1829
												? "7px"
												: "5px",
									}}
								/>
							</Tooltip>
						);
					})}
			</Box>
			<Box sx={styles.containerAnaliseDias}>
				<Box>
					<Typography sx={styles.tituloDias}>
						De {dayjs(dias[0])?.format("DD/MM/YYYY")}
					</Typography>
				</Box>
				<Box sx={styles.containerDivider}>
					<Divider variant="fullWidth">
						<Chip
							label={`${porcentagemGeral}% em atividade`}
							size="small"
							sx={{
								bgcolor:
									porcentagemGeral > 90
										? theme.palette.colors.green.light
										: porcentagemGeral > 80
										? theme.palette.colors.yellow.dark
										: theme.palette.colors.red.dark,
								color: theme.palette.white.main,
								fontWeight: "bold",
							}}
						/>
					</Divider>
				</Box>
				<Box sx={styles.containerHoje}>
					<Typography sx={styles.tituloDias}>
						até {dayjs(dias[dias?.length - 1])?.format("DD/MM/YYYY")}
					</Typography>
				</Box>
			</Box>
		</Box>
	);
}
